export interface Home {
    id: string;
    
  }

  export function fromJson(json: any): Home {
    return {
      id: json.id?.toString() || "",
    };
  }



  export enum RegistrationState {
    NotTreated = 0,
    Treated = 1,
    Treating = 2,
    Withdraw = 3,
    Cancled = 9,
  }
  
  export const RegistrationStates = [
    RegistrationState.NotTreated,
    RegistrationState.Treated,
    RegistrationState.Treating,
    RegistrationState.Withdraw,
    RegistrationState.Cancled,
  ];
  
  const RegistrationStateNames = ["未就诊", "已就诊", "已结算", "已退号"];
  
  export function getRegistrationStateName(state: RegistrationState): string {
    if (RegistrationState.Cancled === state) {
      return "已取消";
    }
    if (state < 0 || state >= RegistrationStateNames.length) {
      return "";
    }
    return RegistrationStateNames[state];
  
  }
  
export function getHomeUrlName(url: any, isAskMedicine: any): string {
  const urlParts = url?.split('?')[0]
  switch (urlParts) {
    case '/home':
      return '首页'
    case '/schoolClinic':
      return '工作站'
    case '/composing':
      return '排班'
    case '/pharmacy/retail':
      return '药店开单'
    case '/appointment':
      return '预约'
    case '/registration':
      return '挂号'
    case '/patients':
      return '医生门诊'
    case '/doctor/station':
      return '医生工作站'
    case '/operationStation':
      return '手术'
    case '/nurse':
      return '处方执行'
    case '/skintest':
      return '皮试管理'
    case '/medicalSation':
      return '医技站'
    case '/payment':
      return '收费'
    case '/retail':
      return isAskMedicine == 1? '处方申请' : '快速开单'
    case '/delivery':
      return '库房发药'
    case '/member':
      return '会员管理'
    case '/sales':
      return '医生销售统计'
    case '/drugStatic':
      return '药品销售统计'
    case '/transactionQuery':
      return '交易查询'
    case '/RevenueReport':
      return '营收报表'
    case '/changeWater':
      return '收费流水'
    case '/statement':
      return '销售员日结'
    case '/wareHouseStatement':
      return '库房报表'
    case '/outpatientReport':
      return '门诊报表'
    case '/dynamicGrossProfitStatement':
      return '毛利动态分析'
    case '/sellingExpenseSummary':
      return '销售费用汇总'
    case '/storage/station':
      return '库房工作站'
    case '/statistics/outpatient':
      return '患者管理'
    case '/settlementApply':
      return '结算清单上传'
    case '/stockSalesUpload':
      return '进销存上传'
    case '/selfPayUpload':
      return '自费上传'
    case '/insuranceWarnLine':
      return '医保控费'
    case 'otherInsuranceAPI':
      return '其他医保接口'
    case '/insuranceDirectory':
      return '医保目录查询'
    case '/outRecipe':
      return '外配处方'
    case '/insuranceSettlementRecord':
      return '医保结算记录'
    case '/failureDirectory':
      return '失效目录查询'
    case '/reconciliation':
      return '医保对账'
    case '/electronicTicketUploads':
      return '电子票据上传'
    case '/electronicMedicalRecordUpload':
      return '电子病历上传'
    case '/ybjdUpload':
      return '医保金盾上传'
    case '/LuqiaoMedicalInsuranceDataUpload':
      return '路桥医保数据上传'
    case '/journal':
      return '卫监警报'
    case '/pre-caution':
      return '事前提醒预警'
    case '/triage':
      return '预检分诊'
    case '/live':
      return '在线直播'
    case '/beforeOperatingManage':
      return '术前管理'
    case '/healthSupervisorUpload':
      return '数据上传'
    case '/dataMaintenance':
      return '数据维护'
    case '/filingManagement':
      return '备案管理'
    case '/reportCard':
      return '报卡管理'
    case '/drinkingWater':
      return '饮用水'
    case '/tenant/manager':
      return '机构管理'
    case '/personalManagement':
      return '个人管理'
    case '/functionSettingTab':
      return '机构设置'
    case '/treatmentLogManagement':
      return '门诊日志管理'
    case '/OReplaceMake':
      return '代煎'
    case '/shoper':
      return '商城'
    case '/productCenter':
      return '产品中心'
    case '/sendMessage':
      return '短信推送'
    case '/weChart':
      return '营销工具'
    case '/coupons':
      return '优惠券管理'
    case '/followUp':
      return '随访'
    case '/chainTransferOutbound':
      return '连锁调拨出库'
    case '/chainClaimBusiness':
      return '连锁申领业务'
    case '/firstTimeBusinessManagement':
      return '首营管理'
    case '/qualityManagement':
      return '质量管理'
    case '/temperatureAndHumidityRecord':
      return '温湿度管理'
    case '/equipmentAndFacilitiesManagement':
      return '设备设施管理'
    case '/pharmaceuticalServiceConsultationRecord':
      return '药学服务咨询记录'
    case '/staffRecord':
      return '员工档案'
    case '/recentTime':
      return '近效期管理'
    case '/storesearch':
      return '库存查询'
    case '/stockMaintenance':
      return '库存养护'
    case '/stockfloor':
      return '库存下限管理'
    case '/InventoryChange':
      return '库存变动流水'
    case '/inventoryRecords':
      return '盘点记录查询'
    case '/recardDrug':
      return '药品购进记录'
    case '/durgsales':
      return '药品销售记录'
    case '/carryover':
      return '库存结转'
    case '/purchaseAcceptance':
      return '采购验收记录'
    case '/supplier':
      return '供应商设置'
    case '/receiving':
      return '收付款'
    case '/supplierDealing':
      return '药品往来'
    case '/purchaseControl':
      return '进货管理'
  }
  return ''
}